<div class="card">
  @if (data().isCompany) {
    <div class="section">
      <div class="text-md-semibold text-gray-900">Kompanija</div>
      <div class="mt-4 info-grid">
        <div class="info-item">
          <app-building-05 stroke="#ADB0B8" width="16" height="16"></app-building-05>
          <div class="info-body">
            <div class="text-sm-semibold text-gray-500">NAZIV KOMPANIJE</div>
            <div class="text-sm-medium text-gray-900">{{ data().name || '-' }}</div>
          </div>
        </div>
        <div class="info-item">
          <app-hash-02 stroke="#ADB0B8" width="16" height="16"></app-hash-02>
          <div class="info-body">
            <div class="text-sm-semibold text-gray-500">PIB</div>
            <div class="text-sm-medium text-gray-900">{{ data().pib || '-' }}</div>
          </div>
        </div>
        <div class="info-item">
          <app-hash-02 stroke="#ADB0B8" width="16" height="16"></app-hash-02>
          <div class="info-body">
            <div class="text-sm-semibold text-gray-500">MATIČNI BROJ</div>
            <div class="text-sm-medium text-gray-900">{{ data().mb || '-' }}</div>
          </div>
        </div>
        <div class="info-item">
          <app-home-line stroke="#ADB0B8" width="16" height="16"></app-home-line>
          <div class="info-body">
            <div class="text-sm-semibold text-gray-500">ADRESA SEDIŠTA</div>
            <div class="text-sm-medium text-gray-900">{{ data().address || '-' }}</div>
          </div>
        </div>
        <div class="info-item">
          <app-marker-pin-01 stroke="#ADB0B8" width="16" height="16"></app-marker-pin-01>
          <div class="info-body">
            <div class="text-sm-semibold text-gray-500">GRAD</div>
            <div class="text-sm-medium text-gray-900">{{ data().city || '-' }}</div>
          </div>
        </div>
        <div class="info-item">
          <app-map-01 stroke="#ADB0B8" width="16" height="16"></app-map-01>
          <div class="info-body">
            <div class="text-sm-semibold text-gray-500">POŠTANSKI BROJ</div>
            <div class="text-sm-medium text-gray-900">{{ data().postalCode || '-' }}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="divider"></div>

    <div class="section">
      <div class="text-md-semibold text-gray-900">Predstavnik</div>
      <div class="mt-4 info-grid">
        <div class="info-item">
          <app-user-circle stroke="#ADB0B8" width="16" height="16"></app-user-circle>
          <div class="info-body">
            <div class="text-sm-semibold text-gray-500">PREDSTAVNIK KOMPANIJE</div>
            <div class="text-sm-medium text-gray-900">{{ data().contactFullName || '-' }}</div>
          </div>
        </div>
        <div class="info-item">
          <app-mail-02 stroke="#ADB0B8" width="16" height="16"></app-mail-02>
          <div class="info-body">
            <div class="text-sm-semibold text-gray-500">EMAIL ADRESA</div>
            <div class="text-sm-medium text-gray-900">{{ data().email || '-' }}</div>
          </div>
        </div>
        <div class="info-item">
          <app-phone stroke="#ADB0B8" width="16" height="16"></app-phone>
          <div class="info-body">
            <div class="text-sm-semibold text-gray-500">KONTAKT TELEFON</div>
            <div class="text-sm-medium text-gray-900">{{ data().phone || '-' }}</div>
          </div>
        </div>
      </div>
    </div>
  } @else {
    <div class="section">
      <div class="text-md-semibold text-gray-900">Informacije klijenta</div>
      <div class="mt-4 info-grid">
        <div class="info-item">
          <app-building-05 stroke="#ADB0B8" width="16" height="16"></app-building-05>
          <div class="info-body">
            <div class="text-sm-semibold text-gray-500">IME I PREZIME</div>
            <div class="text-sm-medium text-gray-900">{{ data().name || '-' }}</div>
          </div>
        </div>
        <div class="info-item">
          <app-home-line stroke="#ADB0B8" width="16" height="16"></app-home-line>
          <div class="info-body">
            <div class="text-sm-semibold text-gray-500">ADRESA</div>
            <div class="text-sm-medium text-gray-900">{{ data().address || '-' }}</div>
          </div>
        </div>
        <div class="info-item">
          <app-marker-pin-01 stroke="#ADB0B8" width="16" height="16"></app-marker-pin-01>
          <div class="info-body">
            <div class="text-sm-semibold text-gray-500">GRAD</div>
            <div class="text-sm-medium text-gray-900">{{ data().city || '-' }}</div>
          </div>
        </div>
        <div class="info-item">
          <app-map-01 stroke="#ADB0B8" width="16" height="16"></app-map-01>
          <div class="info-body">
            <div class="text-sm-semibold text-gray-500">POŠTANSKI BROJ</div>
            <div class="text-sm-medium text-gray-900">{{ data().postalCode || '-' }}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="divider"></div>

    <div class="section">
      <div class="text-md-semibold text-gray-900">Kontakt</div>
      <div class="mt-4 info-grid">
        <div class="info-item">
          <app-mail-02 stroke="#ADB0B8" width="16" height="16"></app-mail-02>
          <div class="info-body">
            <div class="text-sm-semibold text-gray-500">EMAIL ADRESA</div>
            <div class="text-sm-medium text-gray-900">{{ data().email || '-' }}</div>
          </div>
        </div>
        <div class="info-item">
          <app-phone stroke="#ADB0B8" width="16" height="16"></app-phone>
          <div class="info-body">
            <div class="text-sm-semibold text-gray-500">KONTAKT TELEFON</div>
            <div class="text-sm-medium text-gray-900">{{ data().phone || '-' }}</div>
          </div>
        </div>
      </div>
    </div>
  }
</div>
